import {
    FETCH_COMMISSIONS_REQUEST,
    FETCH_COMMISSIONS_SUCCESS,
    FETCH_COMMISSIONS_FAILURE,
    ADD_COMMISSION_REQUEST,
    ADD_COMMISSION_SUCCESS,
    ADD_COMMISSION_FAILURE,
    UPDATE_COMMISSION_REQUEST,
    UPDATE_COMMISSION_SUCCESS,
    UPDATE_COMMISSION_FAILURE,
    DELETE_COMMISSION_REQUEST,
    DELETE_COMMISSION_SUCCESS,
    DELETE_COMMISSION_FAILURE,
  } from '../actions/types';
  
  const initialState = {
    commissions: [],
    loading: false,
    error: null,
    message: '',
  };
  
  export default function commissionReducer(state = initialState, action) {
    switch (action.type) {
      // Handling fetch commissions actions
      case FETCH_COMMISSIONS_REQUEST:
        return { ...state, loading: true, error: null };
  
      case FETCH_COMMISSIONS_SUCCESS:
        return {
          ...state,
          loading: false,
          commissions: action.payload,
          message: 'Commissions loaded successfully',
        };
  
      case FETCH_COMMISSIONS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
          commissions: [],
        };
  
      // Handling add commission actions
      case ADD_COMMISSION_REQUEST:
        return { ...state, loading: true, error: null };
  
      case ADD_COMMISSION_SUCCESS:
        return {
          ...state,
          loading: false,
          commissions: [...state.commissions, action.payload],
          message: 'Commission added successfully',
        };
  
      case ADD_COMMISSION_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      // Handling update commission actions
      case UPDATE_COMMISSION_REQUEST:
        return { ...state, loading: true, error: null };
  
      case UPDATE_COMMISSION_SUCCESS:
        return {
          ...state,
          loading: false,
          commissions: state.commissions.map((commission) =>
            commission.id === action.payload.id ? action.payload : commission
          ),
          message: 'Commission updated successfully',
        };
  
      case UPDATE_COMMISSION_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      // Handling delete commission actions
      case DELETE_COMMISSION_REQUEST:
        return { ...state, loading: true, error: null };
  
      case DELETE_COMMISSION_SUCCESS:
        return {
          ...state,
          loading: false,
          commissions: state.commissions.filter(
            (commission) => commission.id !== action.payload
          ),
          message: 'Commission deleted successfully',
        };
  
      case DELETE_COMMISSION_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      default:
        return state;
    }
  }
  